import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import {
  Field,
  getFormValues,
  SubmissionError
} from 'redux-form'
import {
  Button,
  Confirm,
} from 'semantic-ui-react'

import { StdCard } from 'components'
import { callGRAction } from 'ducks/goodsServiceReceipt'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { Cont } from './styled'

const Approve = (props) => {
  const {
    grDetail = {},
    handleSubmit,
    callGRAction,
    valueForm,
    history
  } = props
  const approverAction = grDetail.actions || ['Approve', 'Revise', 'Reject']
  const sn = grDetail.sn || ''

  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  function submitValidate(action) {
    setSubmitActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        if (action.toLowerCase() === 'reject' || action.toLowerCase() === 'revise' || action.toLowerCase() === 'cancel') {
          if ((valueForm.comment && valueForm.comment.trim().length === 0) || !valueForm.comment) {
            throw new SubmissionError({ comment: 'Required!' })
          }
        }
        setShowConfirm(true)
      })
  }

  function submitAction() {
    setShowConfirm(false)
    callGRAction({
      docId: valueForm.id,
      sn: valueForm.sn,
      action: submitActionName,
      comment: valueForm.comment,
      commentAttachments: valueForm.commentAttachments
    }, history)
  }

  return (
    approverAction.length === 0 ? null :
      <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <Cont>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='comment'
              label='Your Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <Field
              name='commentAttachments'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{ marginTop: '1rem', display: 'flex' }}>
              {
                approverAction.map((item) =>
                  <Button
                    key={item}
                    type='button'
                    color={`${item.toLowerCase() === 'reject' ? 'red' : item.toLowerCase() === 'revise' ? 'orange' : item.toLowerCase() === 'reinterface sap' ? 'blue' : item.toLowerCase() === 'cancel' ? 'red' : 'green'}`}
                    onClick={
                      handleSubmit(() => submitValidate(item))
                    }
                  >
                    {item.toLowerCase() === 'reinterface sap' ?
                      'Re-interface SAP'
                      :
                      pascalCase(item)}

                  </Button>
                )
              }
            </div>
          </div>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </Cont>
      </StdCard>
  )

}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formGR')(state),
  })
}

const mapDispatchToProps = {
  callGRAction
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
